import { IconButton } from '@apia/components';
import useTranslationProps from './FieldLabel/useTranslationProps';
import { useApiaComponentContext } from '../apiaComponent/ApiaComponentContext';

export const GridTranslation = () => {
  const { onClickTranslate, shouldShowTranslateButton } = useTranslationProps({
    children: undefined,
    label: 'asdflala',
  });
  const fieldProps = useApiaComponentContext();

  if (!fieldProps.onGrid) {
    return null;
  }

  return shouldShowTranslateButton ? (
    <IconButton
      {...window.getVariant(
        'layout.common.modals.translation.translateModalButton',
      )}
      className="translateModalButton"
      type="button"
      aria-label={window.BTN_TRANSLATE}
      icon="Translate"
      onClick={onClickTranslate}
    />
  ) : null;
};
